import React from "react";
import { Button } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/FloatingContact.css";

const FloatingContact = () => {
  const phoneNumber = "919121943442"; // Your phone number for WhatsApp & Call
  const email = "indianodysseyofficial@gmail.com"; // Your email
  const whatsappMessage =
    "Hello, I'm interested in your travel services! Could you provide more details?";
  const emailSubject = "Inquiry about Travel Packages";
  const emailBody =
    "Hi, I would like to know more about your travel packages. Please provide details.";

  return (
    <div className="floating-buttons">
      {/* WhatsApp Button */}
      <Button
        variant="success"
        className="floating-btn"
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
          whatsappMessage
        )}`}
        target="_blank"
      >
        <i className="bi bi-whatsapp"></i>
      </Button>

      {/* Phone Call Button */}
      <Button
        variant="primary"
        className="floating-btn"
        href={`tel:+${phoneNumber}`}
      >
        <i className="bi bi-telephone"></i>
      </Button>

      {/* Email Button */}
      <Button
        variant="danger"
        className="floating-btn"
        href={`mailto:${email}?subject=${encodeURIComponent(
          emailSubject
        )}&body=${encodeURIComponent(emailBody)}`}
      >
        <i className="bi bi-envelope"></i>
      </Button>
    </div>
  );
};

export default FloatingContact;
